import styled, { css } from 'styled-components';
import { Typography } from '../../../../global/theme';
import { mobile_xl } from '../../../../global/mediaQueryMixin';
import { AlignCenter, FlexBetween } from '../../../../global/commonStyle';

const Content = styled.div`
  border-radius: var(--border-radius-6);
  border: 0.5px solid var(--border-primary);
  background: var(--background-primary);
  ${mobile_xl(css`
    margin-top: var(--space-8);
  `)}
`;

const First = styled.div`
  ${FlexBetween}
  gap: var(--space-20);
  padding: var(--space-12) var(--space-16);
  border-bottom: 0.5px solid var(--border-primary);
  :last-child {
    border-bottom: none;
  }
`;
const Details = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
`;

const Icons = styled.div`
  ${AlignCenter}
  gap: var(--space-12);
  .active {
    border-radius: var(--border-radius-4);
    background: var(--neutral-secondary);
  }
  ${mobile_xl(css`
    gap: var(--space-8);
  `)}
`;
const Heading = styled.div`
  ${Typography.body_lg_medium}
  color: var(--text-primary);
`;

const Description = styled.div`
  ${Typography.body_md}
  color: var(--text-secondary);
`;

const ApiLink = styled.div`
  color: var(--text-primary);
  padding-top: var(--space-13);
  ${Typography.body_md}
  a {
    ${Typography.body_md}
    color: var(--brand-primary);
    cursor: pointer;
    padding-left: var(--space-5);
    text-decoration: none;
  }
  &.empty-state {
    text-align: center;
    padding-top: var(--space-12);
  }
`;
export { Content, First, Details, Icons, Heading, Description, ApiLink };
